var _defs, _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconChevronDown = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .a_dropdown {\n                fill: #fff;\n            }\n\n            .b_dropdown {\n                fill: none !important;\n            }\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a_dropdown",
    d: "M7.6,8.58,12.818,13.8,18.034,8.58l1.6,1.614-6.818,6.818L6,10.194Z",
    transform: "translate(2.99 2.796)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "b_dropdown",
    width: 32,
    height: 32
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconChevronDown);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_chevron_down.ab0c346a1bc6764c300b5a07216c8c42.svg";